// extracted by mini-css-extract-plugin
module.exports = {"banner-layout":"bannerCard_banner-layout__QWFjE","lovely":"bannerCard_lovely__CRcn2","info-layout":"bannerCard_info-layout__9W1PT"};